import React from "react";
import "./Footer.scss";
import idms from "./assets/idms-white.png";
import logo from "../assets/izobit-logo2.png";
import iso from "./assets/iso.jpeg";
import fb from "./assets/fb.png";
import instagram from "./assets/instagram.png";
import olx from "./assets/olx.png";

export default function Footer() {
  return (
    <footer>
      <div className="footer-content">
        <img src={logo} alt="izobit logo" className="logo" />
        <div className="iso">
          <p className="text certifikat">
            ISO 9001:2015 certifikat <br /> sistem menadžmenta kvalitetom
          </p>
          <img src={iso} alt="iso certifikat" />
        </div>

        <p className="text">
          Proizvodimo i distribuiramo hidroizolacione materijale na bazi
          bitumena, materijale za izgradnju puteva i mnogobrojne hemijske
          proizvode.
        </p>
        <ul className="footer-nav">
          <li>
            <a href="#home">Početna</a>
          </li>
          <li>
            <a href="#products">Proizvodi</a>
          </li>
          <li>
            <a href="#contact">Kontakt</a>
          </li>
          <li>
            <a href="#about-us">O nama</a>
          </li>
        </ul>
      </div>
      <div className="social-media">
        <img src={fb} alt="izobit facebook" />
        <img src={instagram} alt="izobit instagram" />
        <img src={olx} alt="izobit olx" />
      </div>

      {/* created by */}
      <div className="created-by">
          <p>created by</p>
          <a target="_blank" href="https://idms-it.com"><img src={idms} alt="" /></a>
      </div>
    </footer>
  );
}